import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from './components/common/axios-instance.js'; 

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [trackingParameters, setTrackingParameters] = useState({}); // New state for tracking parameters

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await axiosInstance.get('/config'); // Use the Axios instance
        setClients(response.data); // Directly set the clients data
      } catch (err) {
        setError(err.message); // Handle the error
      } finally {
        setLoading(false); // Set loading to false regardless of success or error
      }
    };

    fetchClients();
  }, []); // Runs once when the component mounts

  return (
    <DataContext.Provider value={{ clients, loading, error, trackingParameters, setTrackingParameters }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  return useContext(DataContext);
};